module.exports = __webpack_public_path__ + "static/media/bakri-steps-of-use-poster@2x.e18a55d1.jpg";